/*
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-04-30 16:59:51
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-09-25 17:31:47
 * @FilePath: \pc\coursearrange\config\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


let apiBaseUrl = ''

// 新环境
// apiBaseUrl = 'http://8.140.206.45/api';

//生产正式环境0
// apiBaseUrl = 'http://59.110.160.193/api'; 
// apiBaseUrl = 'https://www.mzkt.top/api';

// 企业地址环境
apiBaseUrl = 'https://www.mzedu.tech/api';
// apiBaseUrl = 'https://www.bjmzedu.com/api';


//测试环境
// apiBaseUrl = 'https://ts.mzedu.tech/api';   
// apiBaseUrl = 'https://ts.mzkt.top/api';
// apiBaseUrl = 'https://gogocoder.com/api';
// apiBaseUrl = 'https://120.26.3.61:80/api';

//本地环境
// apiBaseUrl = 'http://localhost:8081';


// 后台调式 -----
// apiBaseUrl = 'http://192.168.0.132:7101';

// 后台调式 ----
// apiBaseUrl = 'http://192.168.0.112:7101';

// apiBaseUrl = 'http://192.168.0.110:7101';

export default apiBaseUrl;






//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = null
// module chunks = 